<template>
	<div class="container">
		<div class="home">
			<div class="wrap1">
				<notice-bar></notice-bar>
			</div>
			<div class="wrap1">
				<div class="box1 base-flex-between" @click="navMember">
					<div class="inner1">{{ isLogin ? "開始管理" : "職員登入" }}</div>
					<img class="inner2" src="../../assets/images/home/pc/action3.png" alt="" />
				</div>
				<div class="swiper_box2">
					<van-swipe class="van-swipe" :autoplay="3500" :show-indicators="false">
						<van-swipe-item class="van-swipe-item" v-for="(item, index) in swiperList" :key="index"
							@click="gotoNews(item)">
							<div class="swipe_content">
								<img class="swiper_img" :src="downLoadUrl+item.img" alt="">
								<div class="text">{{ item.title }}</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</div>
			<div class="wrap1">
				<div class="action_box">
					<div class="box11 flex-center">
						<div class="inner1"></div>
						<span class="inner2">接案中心登記</span>
					</div>
					<div class="box22">
						<div @click="navTypeInfo(item)" class="inner11" v-for="(item, i) in bankList" :key="i">
							<el-image class="floor1" :src="downLoadUrl + item.img" fit="cover"></el-image>
							<span class="floor2">{{ item.name }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="wrap1">
				<div class="box2">
					<el-image class="inner1-new" v-if="system && system.img" style="width: 500px; height: 500px"
						:src="downLoadUrl + system.img" fit="cover"></el-image>
					<div class="inner1">
						<div class="floor1">公司簡介</div>
						<div class="floor2"></div>
						<div class="floor3" v-html="system.note"></div>
						<div class="floor4" v-html="system.info"></div>
						<div class="floor5 base-flex-between" @click="navMember">
							<div class="group1">了解更多</div>
							<img class="group2" src="../../assets/images/home/pc/action3.png" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="wrap2">
				<div class="title">強大優勢</div>
				<div class="line"></div>
				<div class="box3">開創新時代，助您創造及保管財富</div>
				<div class="box4">
					<div class="inner1" v-for="(item, i) in big_merit" :key="i">
						<el-image class="floor3" :src="downLoadUrl + item.img" fit="cover"></el-image>
						<div class="floor1">{{ item.name }}</div>
						<div class="floor2">
							{{ item.note }}
						</div>
					</div>
				</div>
			</div>
			<div class="wrap3">
				<div class="inner1">監管機構</div>
				<div class="inner2"></div>
				<div class="inner3">經由各國合法金融機構保護投資者資產權益，確保投資者能夠獲得充分的資訊以作出明智的投資決策。​防止詐欺、內線交易等不當行為。</div>
				<div class="inner4" style="flex-wrap: wrap">
					<div class="floor1" v-for="(item, i) in supervise" :key="i">
						<el-image class="group1" :src="downLoadUrl + item.img" fit="cover"></el-image>
						<div class="group2">{{ item.title }}</div>
					</div>
				</div>
			</div>
		</div>
		<base-footer ref="footer"></base-footer>
		<login ref="loginRefs"></login>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations } from "vuex";
	import login from "./components/login";
	import { web_index, getSwiperList, getPeopleBankList } from "@/api/index";
	import { downLoadUrl } from "@/config/net.config.js";
	import noticeBar from './components/notice-bar.vue';
	import baseFooter from "./components/footer.vue"
	export default {
		name: "Home",
		components: {
			login,
			noticeBar,
			baseFooter
		},
		computed: {
			...mapState(["isLogin"]),
		},
		data() {
			return {
				downLoadUrl,
				ballList: [],
				system: {},
				big_merit: {},
				exchange: [],
				supervise: [],
				swiperList: [],
				messageList: [],
				messageInfo: {},
				showModal: false,
				num: 1,
				bankList: [],
			};
		},
		mounted() {
			this.web_index();
			this.getSwiperList();
			this.getPeopleBankList();
		},
		methods: {
			gotoNews(item) {
				console.log('gotoNews')
				this.$router.push({
					path: '/swiperDetail',
					query: {
						id: item.id
					}
				});
			},
			initVideo() {
				let elevideo1 = document.getElementById("headVideo1");
				elevideo1.muted = true;
				elevideo1.play();
				elevideo1.addEventListener(
					"ended",
					() => {
						//结束
						console.log("播放结束1");
					},
					false
				);
			},
			navTypeInfo(item) {
				sessionStorage.setItem("bankItemData", JSON.stringify(item));
				this.$router.push("/typeInfo");
			},
			openMessageModal() {
				this.showModal = true;
			},
			closeMessageModal() {
				this.showModal = false;
			},
			handleOutsideClick(event) {
				// 如果点击的目标不是弹窗内容，关闭弹窗
				if (!this.$refs.modalContent.contains(event.target)) {
					this.closeMessageModal();
				}
			},
			// 格式化时间戳为可读格式
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000); // 假设addtime是秒
				return date.toLocaleString();
			},
			startCarousel() {
				this.timer = setInterval(() => {
					this.currentMessageIndex =
						(this.currentMessageIndex + 1) % this.messageList.length;
				}, 5000); // 每3秒切换一次消息
			},
			stopCarousel() {
				if (this.timer) {
					clearInterval(this.timer);
				}
			},
			web_index() {
				const toast = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: "Loading...",
				});
				let params = {};
				web_index(params)
					.then((res) => {
						if (res.code == 0) {
							this.ballList = res.data.ball;
							this.system = res.data.system;
							this.big_merit = res.data.big_merit;
							this.exchange = res.data.exchange;
							this.supervise = res.data.supervise;
							toast.clear();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {});
			},
			navMember() {
				if (this.isLogin) {
					this.$router.push("/member");
				} else {
					this.$refs.loginRefs.openDialog();
				}
			},
			navDeal() {
				if (this.isLogin) {
					this.$router.push("/coin");
				} else {
					this.$refs.loginRefs.openDialog();
				}
			},
			// 获取首页轮播
			async getSwiperList () {
				const toast = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: "Loading...",
				});
				let params = {
					page: 1
				};
				let res = await getSwiperList(params);
				toast.clear();
				this.swiperList = res.data.data;
			},
			// 获取接案中心列表
			async getPeopleBankList () {
				const toast = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: "Loading...",
				});
				let params = {
					father_id: 0
				};
				let res = await getPeopleBankList(params);
				toast.clear();
				if (res.code != 0) return;
				this.bankList = res.data;
			}
		},
	};
</script>
<style lang="scss" scoped>
	.container{
		flex: 1;
		width: 100vw;
		height: calc(100vh - 65px);
		background: url(../../assets/images/home/pc/memberBg.png) no-repeat 100% 100%;
		overflow: auto;
		
		.home {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-bottom: 30px;
		}
	}

	#headVideo2,
	#headVideo3,
	#headVideo4,
	#headVideo5 {
		width: 100%;
		height: auto;
		object-fit: fill;
		cursor: pointer;
		z-index: 1;
	}

	#headVideo1 {
		width: 100%;
		/* 宽度保持为父容器的100% */
		height: auto;
		/* 高度自动调整 */
		max-width: 1200px;
		/* 最大宽度设置为1200px */
		max-height: 400px;
		/* 最大高度设置为500px */
		object-fit: cover;
		/* 保持比例裁剪，填满容器 */
		cursor: pointer;
		z-index: 1;
	}

	.wrap1 {
		width: 70%;
		position: relative;
		display: flex;
		justify-content: center;
		margin-top: 30px;

		.swiper_box2 {
			width: 100%;
			border-radius: 10px;
			overflow: hidden;
			background-color: #f8f4f0;
			padding: 20px;
			box-sizing: border-box;

			.van-swipe {
				width: 100%;

				.van-swipe-item {
					width: 100%;

					.swipe_content {
						width: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						border-radius: 10px;

						.swiper_img {
							width: 100%;
							border-radius: 5px;
							cursor: pointer;
							object-fit: contain;
						}

						.text {
							flex: 1;
							width: 100%;
							font-size: 18px;
							line-height: 21px;
							margin-top: 14px;
							font-weight: bold;
						}
					}
				}
			}
		}
		
		
		.action_box {
			width: 100%;
			background: #f8f4f0;
			border-radius: 10px;
			padding: 0 20px 30px 20px;
		
			.box11 {
				padding: 30px 0;
		
				.inner1 {
					width: 5px;
					height: 25px;
					background: #396294;
					margin-right: 11px;
				}
		
				.inner2 {
					font-size: 20px;
					color: #396294;
					font-weight: 600;
				}
			}
		
			.box22 {
				display: flex;
				flex-wrap: wrap;
		
				.inner11 {
					width: 25%;
					display: flex;
					flex-direction: column;
					align-items: center;
					margin-bottom: 15px;
					cursor: pointer;
		
					.floor1 {
						width: 90%;
						height: 90%;
						border-radius: 20px;
						margin-bottom: 15px;
					}
		
					.floor2 {
						font-size: 18px;
						color: #333;
						font-weight: 600;
					}
				}
			}
		}

		.box1 {
			cursor: pointer;
			width: 150px;
			height: 50px;
			background: #396294;
			border-radius: 10px;
			padding: 0 13px 0 19px;
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 180px;
			z-index: 10;

			.inner1 {
				font-size: 20px;
				color: #fff;
				font-weight: 500;
			}

			.inner2 {
				width: 24px;
				height: 24px;
			}
		}
	}
	
	
	
	.box2 {
		width: 100%;
		flex-shrink: 0;
		min-height: 540px;
		display: flex;
		justify-content: space-between;
		background-color: #f8f4f0;
		padding: 30px;
		border-radius: 10px;
	
		.inner1-new {
			width: 500px;
			height: 500px;
			flex-shrink: 0;
			margin-right: 33px;
			border-radius: 10px;
		}
	
		.inner1 {
			.floor1 {
				font-size: 30px;
				color: #396294;
				font-weight: 600;
				margin-bottom: 12px;
			}
	
			.floor2 {
				width: 100px;
				height: 5px;
				background: #396294;
				margin-bottom: 24px;
			}
	
			.floor3 {
				font-size: 20px;
				color: #000;
				font-weight: 500;
				line-height: 32px;
				margin-bottom: 14px;
			}
	
			.floor4 {
				font-size: 16px;
				color: #000;
				line-height: 28px;
				margin-bottom: 16px;
			}
	
			.floor5,
			.floor6 {
				cursor: pointer;
				width: 150px;
				height: 50px;
				background: #396294;
				border-radius: 10px;
				padding: 0 13px 0 19px;
	
				.group1 {
					font-size: 20px;
					color: #fff;
					font-weight: 500;
				}
	
				.group2 {
					width: 24px;
					height: 24px;
				}
			}
	
			.floor6 {
				background: #396294;
				margin-top: 10px;
			}
		}
	}
	

	.wrap2 {
		width: 70%;
		background-color: #f8f4f0;
		border-radius: 10px;
		padding: 30px;
		margin-top: 30px;

		.title {
			font-size: 30px;
			color: #396294;
			font-weight: 600;
			margin-bottom: 13px;
		}

		.line{
			width: 100px;
			height: 5px;
			background: #396294;
			margin-bottom: 22px;
		}

		.box3 {
			font-size: 16px;
			color: #000;
		}

		.box4 {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;

			.inner1 {
				width: 22%;
				min-height: 390px;
				transition: all 0.3s ease-in-out;
				background: #fff;
				padding-bottom: 10px;
				margin-top: 30px;
				border-radius: 30px;

				.floor1 {
					font-size: 26px;
					color: #396294;
					font-weight: 600;
					margin-bottom: 26px;
					padding: 0 20px;
				}

				.floor2 {
					font-size: 16px;
					color: #000;
					line-height: 30px;
					padding: 0 20px;
				}

				.floor3 {
					width: 100%;
					height: 180px;
					margin-bottom: 20px;
					border-radius: 30px 30px 0 0;
				}
			}
		}
	}

	.wrap3 {
		width: 70%;
		margin-top: 30px;
		background-color: #f8f4f0;
		border-radius: 10px;
		padding: 30px;

		.inner1 {
			font-size: 30px;
			color: #396294;
			font-weight: 600;
			margin-bottom: 18px;
		}

		.inner2 {
			width: 100px;
			height: 5px;
			background: #396294;
			margin-bottom: 22px;
		}

		.inner3 {
			font-size: 16px;
			color: #000000;
			margin-bottom: 32px;
		}

		.inner4 {
			display: flex;

			.floor1 {
				margin-right: 14px;
				flex-shrink: 0;
				margin-bottom: 16px;

				.group1 {
					width: 264px;
					height: 147px;
				}

				.group2 {
					font-size: 16px;
					color: #000;
					margin-top: 10px;
				}
			}
		}
	}
</style>